import marketplaceRouterPaths from './marketplaceRouterPaths';

export default marketplaceRouterPaths;
